module.exports = __webpack_public_path__ + "static/avatar.dc5bc9bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/avatar.jpg
// module id = 153
// module chunks = 35783957827783 263791100135453